import { render } from "./mega-menu.vue?vue&type=template&id=4fdf46e4"
import script from "./mega-menu.vue?vue&type=script&lang=js"
export * from "./mega-menu.vue?vue&type=script&lang=js"

import "./mega-menu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__